import React from 'react';

import { Text, ThemingProps } from '@chakra-ui/react';

import { handleObjectString } from 'utils/parsers';

type Variants = ThemingProps<'Text'>['variant']

interface DefaultItemProps {
  value: any
  id: string
  suffix?: string
  variant:Variants
}
export function Default({
  value, id, suffix = '', variant,
}:DefaultItemProps) {
  if (!value) {
    return (
      <Text
        variant={variant}
        color="gray.500">N/A
      </Text>
    );
  }
  if (typeof value === 'object') {
    return (
      <Text
        variant={variant}
        color="gray.500">{`${handleObjectString(value, id) || 'N/A'} ${suffix}`}
      </Text>
    );
  }
  return (
    <Text
      variant={variant}
      color="gray.500">{`${value} ${suffix}`}
    </Text>
  );
}
